import type { SxProps } from '@mui/material';
import { Chip, useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { I18N_DE } from '@/i18n/de';
import { UserStatus } from '@/modules/api/backend';

const STATUS_STYLES: Record<UserStatus, { sx?: SxProps<Theme>; variant?: 'filled' | 'outlined' }> = {
  [UserStatus.ACTIVE]: {
    sx: (theme) => ({ bgcolor: theme.palette.secondary.main, color: theme.palette.success.dark }),
    variant: 'filled',
  },
  [UserStatus.INVITED]: {
    sx: (theme) => ({ bgcolor: theme.palette.grey[200], color: theme.palette.text.primary }),
    variant: 'filled',
  },
  [UserStatus.INACTIVE]: {
    sx: {},
    variant: 'outlined',
  },
};

export function UserStatusChip({ status }: { status: UserStatus }) {
  const theme = useTheme();
  const style = STATUS_STYLES[status];
  if (!style) return null;

  return (
    <Chip
      label={I18N_DE.UserStatus[status]}
      size="small"
      sx={typeof style.sx === 'function' ? style.sx(theme) : style.sx}
      variant={style.variant}
    />
  );
}
